import React__default, { memo, useRef } from 'react';
import { Typography, Icon, Portal, Badge } from '@sravni/react-design-system';
import { Fade } from '@sravni/react-design-system/lib/Transition';
import { useStyles, useBoolean, usePositioner } from '@sravni/react-utils';
import modules_af19274f from './partner-badge.module.scss.js';
import { Verification } from './Verification.js';

const { Heading, Text } = Typography;
const PartnerBadge = memo(({ children }) => {
    const cx = useStyles(modules_af19274f);
    const reference = useRef(null);
    const popper = useRef(null);
    const [visible, setVisible] = useBoolean(false);
    const minWidthModifier = {
        name: 'minWidth',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: ({ state }) => {
            state.styles.popper.minWidth = '280px';
        },
    };
    const { referenceRef, popperRef, arrowRef, getReferenceProps, getPopperProps } = usePositioner({
        placement: 'bottom-start',
        modifiers: [
            minWidthModifier,
            {
                name: 'flip',
                options: {
                    fallbackPlacements: ['top', 'right', 'bottom', 'left'],
                },
            },
        ],
    });
    React__default.useEffect(() => {
        let timer = undefined;
        const listener = (event) => {
            // @ts-ignore
            if (!visible && reference.current?.contains(event.target)) {
                setVisible.on();
            }
            // @ts-ignore
            if (visible && !reference.current?.contains(event.target) && !popper.current?.contains(event.target)) {
                timer = setTimeout(() => {
                    setVisible.off();
                }, 50);
            }
        };
        document.addEventListener('mouseover', listener);
        return () => {
            timer && clearTimeout(timer);
            document.removeEventListener('mouseover', listener);
        };
    }, [reference, popper, setVisible, visible]);
    const trigger = (React__default.createElement("div", { ref: referenceRef, ...getReferenceProps({}, reference), className: modules_af19274f.iconWrapper },
        React__default.createElement(Icon, { icon: React__default.createElement(Verification, null) })));
    const tooltip = (React__default.createElement(Portal, null,
        React__default.createElement(Fade, { ref: popperRef, className: cx('bubble'), visible: visible, unmountOnExit: true, ...getPopperProps({ style: { zIndex: 1060 } }, popper) },
            React__default.createElement("div", { ref: arrowRef, className: cx('arrow') }),
            React__default.createElement("div", { className: modules_af19274f.content },
                React__default.createElement(Heading, { level: 5, className: "h-mb-4" }, "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u0442\u043D\u0451\u0440 \u0421\u0440\u0430\u0432\u043D\u0438."),
                React__default.createElement(Text, { size: 14 },
                    "\u042D\u0442\u043E\u0442 \u0437\u043D\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0442 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438, \u0432 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043C\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B. \u041D\u0430\u0448\u0438 \u043C\u043E\u0434\u0435\u0440\u0430\u0442\u043E\u0440\u044B \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u043B\u0438 ",
                    React__default.createElement("span", null, "\u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043B\u0438"),
                    ' ',
                    "\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E\u0431 \u0438\u0445 \u0443\u0441\u043B\u0443\u0433\u0430\u0445. \u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u0438 \u044D\u0442\u0438\u0445 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0439 \u043E\u0442\u0432\u0435\u0447\u0430\u044E\u0442 ",
                    React__default.createElement("span", null, "\u043D\u0430 \u043E\u0442\u0437\u044B\u0432\u044B"),
                    " \u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u0421\u0440\u0430\u0432\u043D\u0438 \u0432 \u043F\u0435\u0440\u0432\u0443\u044E \u043E\u0447\u0435\u0440\u0435\u0434\u044C.")))));
    return (React__default.createElement("div", { className: modules_af19274f.badgeWrapper },
        React__default.createElement(Badge, { color: "light", text: trigger, shape: "circle", placement: "bottom-end", className: cx('badge') }, children),
        tooltip));
});

export { PartnerBadge };
//# sourceMappingURL=PartnerBadge.js.map
